export const MESSAGE_LIST = 'MESSAGE_LIST';

export function messageList(data) {
    return {
        type:MESSAGE_LIST,
        payload: {data},
    };
}
export const MESSAGE_UPDATE = 'MESSAGE_UPDATE';

export function messageUpdate(id) {
    return {
        type:MESSAGE_UPDATE,
        payload: {id},
    };
}
